import { put, call } from 'redux-saga/effects'
import ResourcesActions from 'store/models/resources'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

export function* updateResourceProduct({ body, callback }) {
    try {
        const { message, payload } = yield call(() =>
            submitToApi({
                body,
                method: 'POST',
                path: URL.DIRECTORY.V3_DIRECTORY_SUPPLIER_UPDATE,
                url: URL.DIRECTORY.BASE,
            })
        )
        yield put(ResourcesActions.updateResourceProductSuccess(payload.data))
        callback(message, 'success')
    } catch (error) {
        yield put(ResourcesActions.updateResourceProductFailure())
        callback(error, 'error')
    }
}

export function* updateShopifyResource({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({ body, method: 'PUT', path: URL.DIRECTORY.V3_DIRECTORY_SHOPIFY_RESOURCE_MAPPING, url: URL.DIRECTORY.BASE })
        )
        yield put(ResourcesActions.updateShopifyResourceSuccess())
        callback(message, 'success')
    } catch (error) {
        yield put(ResourcesActions.updateShopifyResourceFailure(error))
        callback(error, 'error')
    }
}
